export default {
    CHOCOLATE: "Chocolate",
    BANANA: "Banana",
    CHOCOLATE_PEANUT_BUTTER: "Chocolate Peanut Butter",
    STRAWBERRY: "Strawberry",
    VANILLA: "Vanilla"
  };
  